import { motion } from "framer-motion";
import { useLang } from "@/context/LanguageContext";
import { useSite } from "@/context/SiteContentContext";
import { Reveal, SectionTag } from "./Reveal";
import { IMAGES } from "@/i18n/assets";

export default function WorkStages() {
  const { t, lang } = useLang();
  const { settings } = useSite();
  const items = t.work.items.map((st, i) => ({
    t: settings[`stage_${i}_title_${lang}`] || st.t,
    d: settings[`stage_${i}_desc_${lang}`] || st.d,
  }));
  return (
    <section id="work" className="relative section-pad overflow-hidden" data-testid="work-section">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-4">
            <div className="lg:sticky lg:top-28">
              <Reveal><SectionTag>{t.work.tag}</SectionTag></Reveal>
              <Reveal delay={0.05}>
                <h2 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold mt-5 mb-6">{t.work.title}</h2>
              </Reveal>
              <Reveal delay={0.1}>
                <div className="rounded-3xl overflow-hidden border border-white/10 aspect-video lg:aspect-[4/3]">
                  <img src={IMAGES.teamMeeting} alt="Process" className="h-full w-full object-cover" />
                </div>
              </Reveal>
            </div>
          </div>

          <div className="lg:col-span-8">
            <div className="divide-y divide-white/8">
              {items.map((stage, i) => (
                <Reveal key={i} delay={(i % 3) * 0.05}>
                  <motion.div
                    whileHover={{ x: 8 }}
                    className="group relative flex items-start gap-6 py-7"
                    data-testid={`work-stage-${i}`}
                  >
                    <span className="text-6xl sm:text-8xl font-extrabold leading-none shrink-0 transition-colors duration-300" style={{ color: "rgba(148,163,184,0.12)" }}>
                      {String(i + 1).padStart(2, "0")}
                    </span>
                    <div className="pt-2">
                      <h3 className="text-xl sm:text-2xl font-bold mb-2 group-hover:text-primary transition-colors">{stage.t}</h3>
                      <p className="text-slate-400 leading-relaxed">{stage.d}</p>
                    </div>
                  </motion.div>
                </Reveal>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
